// src/includes/Header.js
import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header className="py-4 px-6 flex items-center justify-between bg-gray-900">
      <img
        src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/logo-J9azQPgps5nEQJgcMutOHujoHWGnYU.png"
        alt="Team CodeMe Logo"
        className="w-16"
      />
      <nav className="space-x-6">
        <Link to="/" className="text-green-500 hover:text-green-400">
          Home
        </Link>
        <Link to="/events" className="text-green-500 hover:text-green-400">
          Events
        </Link>
      </nav>
    </header>
  );
};

export default Header;